export default {"src":"/_next/static/media/wifi.5c106054.svg","height":24,"width":24};